import { CanonicalLoad, ClientLoadModel } from '@numeo/types-core'

export const makeLoadKey = (load: ClientLoadModel): string =>
    [
        load.origin.city,
        load.origin.stateProv,
        load.destination.city,
        load.destination.stateProv,
        load.emailHistory?.details?.weight || load.shipmentDetails.maximumWeightPounds || '',
        load.posterInfo?.mcNumber || '',
        load.equipmentType || '',
    ].join('|')

export const makeIngestKey = (ing: CanonicalLoad): string =>
    [ing.pickupCity, ing.pickupStateProv, ing.deliveryCity, ing.deliveryStateProv, ing.weightLbs || '', ing.brokerMc || '', ing.equipmentType || ''].join('|')

export const getMatchingCriteriasKeys = (loads: ClientLoadModel[]): string[] => loads.map(makeLoadKey)

export const getLoadsExternalIds = (loads: ClientLoadModel[]): string[] => loads.map((load) => load.externalId)

/**
 * Return the ingested load if its externalId exists in the list, otherwise null.
 */
export const filterByExternalIds = (externalIds: string[], loadIngest: CanonicalLoad): CanonicalLoad | null => {
    const keys = new Set(externalIds)
    return keys.has(loadIngest.externalId) ? loadIngest : null
}

/**
 * Return the ingested load if its matching-criteria key matches
 * at least one load, otherwise null.
 */
export const filterByMatchingCriteriasKeys = (keys: string[], loadIngest: CanonicalLoad): CanonicalLoad | null => {
    const keysSet = new Set(keys)
    return keysSet.has(makeIngestKey(loadIngest)) ? loadIngest : null
}
